import { Mutation } from 'vuex';
import { IModuleState } from './types';

// oss 文件列表
export const setOssFiles: Mutation<IModuleState> = (state, payload) => {
  state.ossFiles.data = payload.data;
  state.ossFiles.loading = !!payload.loading;
};

// 已发布的文件
export const setPublishedFiles: Mutation<IModuleState> = (state, payload) => {
  state.publishedFiles.data = payload.data;
  state.publishedFiles.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.data = payload.data;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 上传的验证信息
export const setUploadPolicy: Mutation<IModuleState> = (state, payload) => {
  state.uploadPolicy.data = payload.data;
  state.uploadPolicy.loading = payload.loading;
};

// 面包屑导航
export const setBreadcrumbs: Mutation<IModuleState> = (state, payload) => {
  state.breadcrumbs = payload;
};

// 文件树
export const setFileTree: Mutation<IModuleState> = (state, payload) => {
  state.fileTree = payload;
};

// 是否需要刷新左边栏
export const setReload: Mutation<IModuleState> = (state, payload) => {
  state.reload.needReload = !!payload.needReload;
  state.reload.uploadPath = payload.uploadPath;
};

// 资源管理器的 tab 页签
export const setTab: Mutation<IModuleState> = (state, payload) => {
  state.tab = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
